import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import { 
    allStudents,
    addPuttPerformance,
    fetchPuttDistance,
 } from 'Actions';

 import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class AddItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(),
            student:this.props.data.student, 
            loader:false,
            sepmore:1,
            chkcount:0,
            formValues: [{ puttlength:"", noputt:"", putttype:"", right : "", left : "", short : "", long : "", avgputt:"", strokes:""}],
            editable: {},
            totavgpoints:0,
        };
    }

    selstudent = (evt) =>{
        var stdid =evt.value;
        this.setState({ student:stdid });
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        
    }    

    addHandleSubmit(event) {
        event.preventDefault();
        this.setState({ loader: true });
    
        const { formValues } = this.state;
        const isAnyRowFilled = formValues.every((row) => {
            
            if(row.noputt==1){
                return true;
            }else{    
                return row.right !== "" || row.left !== "" || row.short !== "" || row.long !== "";
            }
        });
        
        if (isAnyRowFilled) {
            var sepmore = this.state.sepmore;
            this.props.addPuttPerformance(event, sepmore).then((data) => {
                if (data.status === 1) {
                    this.setState({
                        loader: false,
                        student: '',
                        seldate: '',
                    });
    
                    document.getElementById("addform").reset();
                    setTimeout(() => {
                        this.props.onClick();
                    }, 2000);
                }
            });
        } else {
            alert("Please fill at least one of the fields (RIGHT (FT), LEFT (FT), SHORT (FT), LONG (FT))");
            this.setState({ loader: false });
        }
    }
    
    
    addFormFields() {
        var chktotal=this.state.sepmore;
        var totalsep=chktotal+1;
        this.setState(({
          sepmore:totalsep,  
          formValues: [...this.state.formValues, { puttlength:"", noputt:"", putttype:"", right : "", left : "", short : "", long : "", avgputt:"", strokes:"" }]
        }))
    }
    
    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal=this.state.sepmore;
        var totalsep=chktotal-1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore:totalsep });
        this.chartValue(i);
    }

    handleChange(i, e) {
        let formValues = this.state.formValues;    
          
            var inputval=e.target.value;
            var digit=this.digits_count(inputval);

            if(e.target.name=='puttlength'){
                if(inputval!=""){
                    var putlgnt=formValues[i]['noputt'];
                    this.props.fetchPuttDistance(inputval).then((data) => {   
                        var resdata=data.data;
                        
                        if(data.status==1){     
                            var avgval=resdata.value;
                            formValues[i]['avgputt'] = avgval; 
                            this.setState({ formValues });  
                            
                            if(putlgnt!=""){
                                var aperct=avgval-putlgnt;
                                var strokes = aperct.toFixed(3);
                                formValues[i]['strokes'] = strokes; 
                                this.setState({ formValues });
                            }
                        }
                    });
                }else{
                    formValues[i]['avgputt'] = ''; 
                    this.setState({ formValues });
                }
                this.chartValue(i+1);
            }else if(e.target.name=='noputt'){ 
                var avgputt=formValues[i]['avgputt'];
                if(inputval!=""){
                    var aperct=avgputt-inputval;
                    var strokes = aperct.toFixed(3);
                    formValues[i]['strokes'] = strokes; 
                    this.setState({ formValues });
                }else{
                    formValues[i]['strokes'] = ''; 
                    this.setState({ formValues });
                }

                if(inputval==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, 
                                    ['right_'+i]: true,
                                    ['left_'+i]: true,
                                    ['short_'+i]: true,
                                    ['long_'+i]: true 
                                }
                    }));
                }else if(inputval!=""){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, 
                                    ['right_'+i]: false,
                                    ['left_'+i]: false,
                                    ['short_'+i]: false,
                                    ['long_'+i]: false 
                                }
                    }));    
                }

                this.chartValue(i+1);
            }else if(e.target.name=='right'){ 
                var disleft=this.state.editable['left_'+i];               
                if(disleft==true&&inputval!=''){
                 
                }else if(inputval==""){              
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['left_'+i]: !editable['left_'+i] }
                    }));
                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['left_'+i]: !editable['left_'+i] }
                    }));  
                }
            }else if(e.target.name=='left'){
                var disright=this.state.editable['right_'+i];               
                if(disright==true&&inputval!=''){
                 
                }else if(inputval==""){              
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['right_'+i]: !editable['right_'+i] }
                    }));
                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['right_'+i]: !editable['right_'+i] }
                    }));  
                }
            }else if(e.target.name=='short'){
               
                var dislong=this.state.editable['long_'+i];               
                if(dislong==true&&inputval!=''){
                 
                }else if(inputval==""){              
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['long_'+i]: !editable['long_'+i] }
                    }));
                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['long_'+i]: !editable['long_'+i] }
                    }));  
                }
            }else if(e.target.name=='long'){
               
                var disshort=this.state.editable['short_'+i];               
                if(disshort==true&&inputval!=''){
                 
                }else if(inputval==""){              
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['short_'+i]: !editable['short_'+i] }
                    }));
                }else if(digit==1){
                    this.setState(({ editable }) => ({
                        editable: { ...editable, ['short_'+i]: !editable['short_'+i] }
                    }));  
                }
            }

        formValues[i][e.target.name] = e.target.value; 
        this.setState({ formValues }); 

    }

    digits_count(n) {
        var count = 0;
        if (n >= 0.1) ++count;
      
        while (n / 10 >= 1) {
          n /= 10;
          ++count;
        }
      
        return count;
    }

    chartValue(total){        
        
        let formValues = this.state.formValues; 
        var st=0;
        for(let d = 0; d<total; d++) {
            var puttval=formValues[d]['strokes'];            
            if(puttval!=""){
            st=parseFloat(st)+parseFloat(puttval);
            }
        }           
        var totavg=parseFloat((st).toFixed(4));     
        this.setState({ totavgpoints:totavg});
    }

    

    handleNumberic(e) {               
        if (!/[0-9,.]/.test(e.key)) {
            e.preventDefault();
        } 
    }


render() {

    const { studentlists, loading} = this.props;   
    const allstudent=studentlists.map((stdval) => {  
        return {
           label: stdval.student,  
           value: stdval.uudID
        }
    });
    
    const stdrole=localStorage.getItem('stdrole');
      return(
        <div>
            <div className="col-lg-12">
                <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard heading="Create Putt Performance">
                                    <div className="row"> 
                                        <div className="col-sm-12 col-lg-4"> 
                                                <Label for="Select">Student *</Label>
                                                <FormGroup>    
                                                    <Label for="Select">Student *</Label>                                                
                                                    <Selectsearch id="student" name="student" options={allstudent}  rules={{ required: 'Please select an student'}} value={stdrole==1? allstudent[0] : allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                                                </FormGroup>
                                        </div> 
                                        
                                        <div className="col-sm-12 col-lg-4">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}  
                                                        dateFormat='yyyy-MM-dd'
                                                        selectsEnd
                                                        maxDate={new Date()}   
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"                                               
                                                    /> 
                                            </FormGroup>                                          
                                        </div> 
                                         
                                        <div className="col-sm-12 col-lg-12"> 
                                            <div className="form-group">
                                                <div className="table-responsive">
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow hover>   
                                                                <TableCell align="center" width={'10%'}>PUTT LENGTH (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}>NO OF PUTT</TableCell>
                                                                <TableCell align="center" width={'20%'}>PUTT TYPE</TableCell>
                                                                <TableCell align="center" width={'10%'}>RIGHT (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}>LEFT (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}>SHORT (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}>LONG (FT)</TableCell>
                                                                <TableCell align="center" width={'10%'}>PRO AVG</TableCell>
                                                                <TableCell align="center" width={'10%'}>STROKES</TableCell>
                                                                <TableCell align="center" width={'10%'}>DELETE</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>

                                                        {this.state.formValues.map((element, i) => (
                                                             
                                                            <TableRow key={i}>
                                                            <TableCell><input type="text" name={'puttlength'} id={'puttlength_'+i} value={element.puttlength || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" required/></TableCell>
                                                            <TableCell><input type="text" name={'noputt'} id={'noputt_'+i} value={element.noputt || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" required/></TableCell>
                                                            <TableCell>
                                                                <select  name="putttype" id={"putttype_"+i}  className="form-control form-control-alternative" 
                                                                value={element.putttype || ""} onChange={e => this.handleChange(i, e)} required>
                                                                    <option value=""> </option>
                                                                    <option value="1">Straight flat</option>
                                                                    <option value="2">Straight uphill</option> 
                                                                    <option value="3">Straight downhill</option> 
                                                                    <option value="4">Right to left flat</option> 
                                                                    <option value="5">Right to left uphill</option> 
                                                                    <option value="6">Right to left downhill</option> 
                                                                    <option value="7">Left to right flat</option> 
                                                                    <option value="8">Left to right uphill</option> 
                                                                    <option value="9">Left to right downhill</option>                                                                                                                
                                                                </select>
                                                            </TableCell>
                                                            <TableCell><input type="text" name={'right'} id={'right_'+i} disabled={this.state.editable['right_'+i] } value={element.right || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell><input type="text" name={'left'} id={'left_'+i} disabled={this.state.editable['left_'+i]} value={element.left || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell><input type="text" name={'short'} id={'short_'+i} disabled={this.state.editable['short_'+i]} value={element.short || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell><input type="text" name={'long'} id={'long_'+i} disabled={this.state.editable['long_'+i]} value={element.long || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" /></TableCell>
                                                            <TableCell><input type="text" name={'avgputt'} id={'avgputt_'+i} value={element.avgputt || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" readOnly/></TableCell>
                                                            <TableCell><input type="text" name={'strokes'} id={'strokes_'+i} value={element.strokes || ""} onKeyPress={e => this.handleNumberic(e)}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative" readOnly/></TableCell>
                                                            <TableCell>
                                                                {
                                                                    i ? 
                                                                    <IconButton style={{ width: "10px", height: "10px"}} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton> 
                                                                        : null
                                                                }
                                                            </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell><strong>Total Strokes Gained</strong></TableCell>
                                                        <TableCell><input type="text" name={'totalavg'} value={this.state.totavgpoints} className="form-control form-control-alternative" readOnly/></TableCell>
                                                        <TableCell></TableCell>                                        
                                                        </TableRow>
                                                        </TableBody>
                                                    </Table>   
                                                </div>  
                                            </div>      
                                        </div>   
                                        <div className="col-lg-12">
                                            <div className="dd">
                                                <button  className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                            </div>
                                        </div>                                     

                                       <div className="col-lg-12">
                                        <div className="form-group"> 
                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" disabled={this.state.loader}>Submit</button>
                                            <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button>   
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
            </div>
            {this.state.loader &&
            <div className="col-lg-12">
                <ProgressLoader />
            </div>
            }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ mostlyused}) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };
   
}


export default connect(mapStateToProps, {
    allStudents,
    addPuttPerformance,
    fetchPuttDistance,
})(AddItems);
